import { ProjectAnalysesSectionPage } from '@/pages/ProjectAnalysesSectionPage';

export function ProjectAnalysesRapportsPage() {
  return <ProjectAnalysesSectionPage sectionTitle="Rapports" />;
}

